import { useMemo } from 'react';
import { Gateway } from '../../../api/gateway/Gateway';

import { EmailSuggestionStore } from './EmailSuggestionStore';

export const useCreateEmailSuggestionStore = () =>
	useMemo(() => {
		const gateway = new Gateway();
		const store = new EmailSuggestionStore(gateway.emailSuggestion());

		return store;
	}, []);
